/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-16 11:33:19
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-19 23:41:28
 * @FilePath: /mooctest.com/src/api/class.js
 */
// 班级相关api
import request from "../utils/request";

// 获取班级列表（搜索）
export function classListGet(keyword, activePage) {
  return request({
    url: "/searchGroups",
    method: "GET",
    params: {
      keyword,
      activePage,
    },
  });
}

// 获取班级列表（新）
export function myClassListGetNew(userId) {
  return request({
    url: "/group",
    method: "GET",
    params: {
      ownerId: userId,
    },
  });
}

// 获取我加入的班级列表
export function myClassListGet(userId) {
  return request({
    url: `/group/user/${userId}`,
    method: "GET",
  });
}

// 加入班级
export function joinInClass(userId, classId, managerName) {
  return request({
    url: `/group/user/${userId}`,
    method: "POST",
    data: {
      id: classId,
      managerName,
      captcha: "summer",
    },
  });
}

// 获取班级成员
export function classMemberGet(groupId, activePage) {
  return request({
    url: `/group/${groupId}/user`,
    method: "GET",
    params: {
      sortBy: "id",
      sortOrder: "desc",
      activePage,
    },
  });
}

// 获取班级详细信息
export function classDetailGet(groupId) {
  return request({
    url: `/group/${groupId}`,
    method: "GET",
  });
}
